import { quantityOrderedStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsQuantityOrdered";
import { inputStyles } from "@store/theme/common/mixins";
import { css } from "styled-components";

Object.assign(quantityOrderedStyles, {
    quantityOrdered: {
        cssOverrides: {
            formField: css`
                margin-top: 0;
                width: auto;
            `,
            inputSelect: css`
                ${inputStyles()}
                width: 85px;
                height: 48px;
                text-align: center;
            `,
        },
    },
});
